import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { unwrapAxiosData } from "@/lib/api/query-utils";
import { indexPropertyKindUnits } from "@/features/shared/widgets/map/time-series/time-series-parameter-option.utils";
import { warnUntranslatedPropertyKinds } from "@/lib/parameters/property-kind-label";

export const propertyKindKeys = {
  all: () => ["parameters", "property_kinds"] as const,
};

/** Global, rarely-changing catalogue: property kind id → selectable display units. */
export function usePropertyKindUnitsIndexQuery(enabled = true) {
  return useQuery({
    queryKey: propertyKindKeys.all(),
    queryFn: async () => {
      const propertyKinds = await unwrapAxiosData(api.parameters.listPropertyKinds());
      // In the queryFn (not `select`) so it runs once per fetch, not per observer.
      warnUntranslatedPropertyKinds(propertyKinds.map((kind) => kind.id));
      return propertyKinds;
    },
    select: indexPropertyKindUnits,
    staleTime: Infinity,
    enabled,
  });
}
